import { useMemo } from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { translations } from '../i18n/translations';

const getNestedValue = (obj, path) => {
  if (!obj) return undefined;
  return path.split('.').reduce((acc, part) => {
    if (acc && Object.prototype.hasOwnProperty.call(acc, part)) {
      return acc[part];
    }
    return undefined;
  }, obj);
};

export const useTranslations = () => {
  const { locale, setLocale } = useLocale();

  const dictionary = translations[locale] || translations.fi;

  const t = useMemo(
    () => (path, fallback = '') => {
      const value = getNestedValue(dictionary, path);
      return typeof value === 'string' ? value : fallback;
    },
    [dictionary]
  );

  return {
    t,
    locale,
    setLocale,
  };
};






